// extracted by mini-css-extract-plugin
module.exports = {"App":"achievements_App__1wTZP","card":"achievements_card__14x0I","cardtop":"achievements_cardtop__2EAcZ"};